import React, { useEffect, useRef, useState } from 'react';
import './Cyber.css';
import IndicatorDots from '../Cyber/IndicatorDots/IndicatorDots';
import theHood from './Sections/theHood.png';
import ResilienceTester from './Sections/ResilienceTester';
import TheGreenHood from './Sections/TheGreenHood';

const Cyber = () => {
  const resilienceTestersRef = useRef(null);
  const theGreenHoodRef = useRef(null);

  const [activeSection, setActiveSection] = useState('introduction');

  const scrollToSection = (ref, section) => {
    if (ref && ref.current) {
      setActiveSection(section); // עדכן מיידית את המצב
      ref.current.scrollIntoView({ behavior: 'smooth' }); // גלול למיקום
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = [
        { ref: resilienceTestersRef, name: 'resilienceTesters' },
        { ref: theGreenHoodRef, name: 'theGreenHood' },
      ];

      let newActiveSection = activeSection;

      sections.forEach(({ ref, name }) => {
        if (ref.current) {
          const rect = ref.current.getBoundingClientRect();
          const isInViewport = rect.top < window.innerHeight && rect.bottom >= 0;

          // Update the active section based on which section is currently visible
          if (isInViewport && rect.top <= window.innerHeight * 0.3) {
            newActiveSection = name;
          }
        }
      });

      // Update active section only if it has changed
      if (newActiveSection !== activeSection) {
        setActiveSection(newActiveSection);
      }
    };

    window.addEventListener('scroll', handleScroll);
    // Call handleScroll immediately to handle the state on page load
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [activeSection]);

  return (
    <div className="main-page">
      <IndicatorDots
        activeSection={activeSection}
        scrollToSection={scrollToSection}
        resilienceTestersRef={resilienceTestersRef}
        theGreenHoodRef={theGreenHoodRef}
      />

      <div ref={resilienceTestersRef} className="section">
        <div className="text-image-container">
          <ResilienceTester />
        </div>
      </div>

      <div ref={theGreenHoodRef} className="section">
        <div className="text-image-container">
          <img src={theHood} alt="theHood" className="services-image" />
          <TheGreenHood />
        </div>
      </div>
      
      {/* Safari-only invisible block that only appears on mobile Safari - positioned at the bottom */}
      <div className="safari-mobile-block">
        {/* This block is invisible and only appears on mobile Safari browsers */}
      </div>
      
      {/* Invisible block for additional scrolling at the end of the page */}
      <div className="scroll-extension">
        {/* This block is invisible and allows additional scrolling at the end of the page */}
      </div>
    </div>
  );
};

export default Cyber;
